// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import React from "react"
import { SelectionMode } from "../Selection"
import { Link } from "@mui/material"
import { length } from "ramda"
import { useTableContext } from "../../provider"
import { useSelectionHintStyles } from "./styles"

export const SelectionHint = (props: any) => {


  const ctx = useTableContext()
  const { notification } = useSelectionHintStyles()

  const toggleMode = () => {
    ctx.selection.api.toggleMode()
  }

  const { index } = props
  const { pageSize } = ctx.data.state

  if (!ctx.props.selectionAllowSelectAll) return null
  if (index !== 0) return null
  if (ctx.selection.state.mode < SelectionMode.Page) return null
  if (ctx.props.total <= pageSize) return null

  const templates = {
    selectAll: i18n("Framework.TableSelectionHint:SelectAllInTable"),
    selectPage: i18n("General:SelectAll"),
    selectPageHint: i18n("General:SelectPageHint"),
    selectTableHint: i18n("General:SelectTableHint")
  }

  const selectAll = templates.selectAll.replace("{0}", `${ctx.props.total}`)
  const selectPage = templates.selectPage.replace("{0}", `${length(ctx.props.rows)}`)
  const selectPageHint = templates.selectPageHint.replace("{0}", `${length(ctx.props.rows)}`)
  const selectTableHint = templates.selectTableHint.replace("{0}", `${ctx.props.total}`)

  const hint = ctx.selection.state.mode === SelectionMode.All
    ? { text: selectTableHint, link: selectPage }
    : { text: selectPageHint, link: selectAll }

  return (
    <div className={notification}>
      <span>{hint.text}&nbsp;</span>
      <Link
        component="button"
        onClick={toggleMode}
        underline="hover"
        variant="inherit"
        color="#0055b0">
        {hint.link}
      </Link>
    </div>
  )
}
